<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="CREATE STAFF"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createStaffForm.name"   name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="createStaffForm.email" class="w-full"  name="email" type="email" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Address</small>
              <vs-textarea v-model="createStaffForm.address_1" height="100px"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dep" name="dep" rules="required" v-slot="{ errors }">
                <small class="label">Departments</small>
                <!--            <v-select multiple :closeOnSelect="false" v-model="selected" :options="options.filter(o => selected.indexOf(o) < 0)" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
                <v-select name="dep" label="name" multiple :closeOnSelect="false" v-model="selected" :options="departments.filter(o => selected.indexOf(o) < 0)" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Group</small>
                <v-select name="user_group" v-model="createStaffForm.role_id" label="name" :closeOnSelect="true"  :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_1" name="contact_1" rules="required|contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">telephone</small>
                <vs-input v-model="createStaffForm.contact_1" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_2" name="contact_2" rules="contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="createStaffForm.contact_2" class="w-full"  name="contact_2" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const RolesRepository = RepositoryFactory.get('roles');
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      roles: [],
      selectedStaff: {},
      departments: [],
      selected: [],
      updateStaffSelected: [],
      createStaffForm: {}
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.loadRoles();
        this.loadDepartments();
      } catch (error) {

      }
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createStaffForm.department_ids = this.selected.map((dep) => dep.id);
         this.createStaffForm.role_id = this.createStaffForm.role_id.id;
         await StaffRepository.createStaff(this.createStaffForm)
         this.showSuccessMessage('New staff created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

    async loadDepartments() {
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
    },

    async loadRoles() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.50
      });
      this.roles = [];
      const {data} = await RolesRepository.get(' ', '', '', '' )
      this.roles =  data.data
      await this.$vs.loading.close('#popup > .con-vs-loading')
    },

    async getStaff(id) {
      const { data } = await StaffRepository.getStaff(id)
      this.selectedStaff = data.data
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
